import loginProps from "common/managers/loginProps";

var standardPageSize = 50;

export default {

    /**
     * The default page size users should see in non-configurable paging situations.
     */
    pageSize: loginProps.get().pageSize,

    /**
     * Get the paging options for user-configurable paging.  Returns an array of page sizes.
     * @return {number[]}
     */
    pageSizes: function() {
        return [10, 25, standardPageSize, 100];
    },

    /**
     * Takes the given page size and validates it against current system settings, to make sure it
     * is a valid option given the current paging settings.  If valid, it is returned as-is.
     * If invalid, it's transformed to 50.
     *
     * An example of how something could become invalid: max page size system property is set to 200 in 10.13.
     * A user searches, messes with page sizes, and saves 200 as their user setting.
     * The system is then upgraded to 10.14 and the system property for max page size is removed, so max is now 100.
     * The old value of 200 is now invalid, and should be changed to 50 (standard size).
     *
     * @param size
     * @return {*}
     */
    validatePageSize: function(size) {
        if (this.pageSizes().indexOf(size) == -1) {
            size = standardPageSize;
        }
        return size;
    }
};